import styled from "styled-components"
import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import CornerIcon from "./corner.svg"

export const Text1 = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 1vw;
  color: #3b1a53;
  margin: 0;
  padding: 0;
  margin-bottom: 1em;
`

export const Text2 = styled.p`
  font-family: Lora-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 0.7vw;
  color: #3b1a53;
  margin: 0;
  padding: 0;
  line-height: 150%;
  margin-bottom: 1em;
`

export const Text3 = styled.p`
  font-family: Lora-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 0.7vw;
  color: #3b1a53;
  margin: 0;
  padding: 0;
  line-height: 150%;
  margin-bottom: 0em;
`

export const Text4 = styled.p`
  font-family: Lora-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 0.7vw;
  color: #c61a41;
  margin: 0;
  padding: 0;
  line-height: 150%;
  margin-bottom: 0em;
`

export const Holder = styled(motion.div)`
  position: fixed;
  width: 100vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
`

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
`

export const BackButton = styled(Link)`
  position: absolute;
  left: 1rem;
  bottom: 1rem;
`
export const LeftHolder = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 30%;
  min-width: 370px;
`

export const MiddleHolder = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  min-width: 370px;
`

export const RightHolder = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 40%;
  background: url("/assets/textures/gallery/coronation_square/img-1e.jpg");
  background-size: auto 100%;
  background-position: center;
`
export const RightPic = styled.img`
  width: 70vw;
`
export const LeftPic = styled.div`
  width: 100%;
  height: 33%;
  background: url("/assets/textures/gallery/residencs/img-2b.jpg");
  background-size: 100% auto;
  background-position: center;
`
export const LeftBottomHolder = styled.div`
  height: 67%;
  padding: 2vw 2vw 3.5rem 2vw;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`
export const TaylorPic = styled.img`
  width: 95%;
  margin-bottom: 1vw;
`
export const Divider = styled.div`
  width: 100%;
  height: 2px;
  margin: 1vw 0;
  background-color: #3b1a53;
`

export const MiddleTopHolder = styled.div`
  height: 45%;
  padding: 3vw;
  display: flex;
  flex-direction: column;
`
export const MiddleBottomHolder = styled.div`
  position: relative;
  padding: 3vw;
  display: flex;
  flex-direction: column;
  background-color: #d0c6c8;
  height: 55%;
`
export const CaptionHolder = styled.div`
  position: relative;
  padding: 0 2vw;
  font-style: normal;
  font-weight: 600;
  font-size: 1.2vw;
  color: #3b1a53;
  text-align: justify;
  line-height: 150%;
  &:after {
    content: "";
    background-image: url(${CornerIcon});
    background-size: cover;
    width: 1vw;
    height: 1vw;
    position: absolute;
    top: -1.5rem;
    left: 0;
  }

  &:before {
    content: "";
    background-image: url(${CornerIcon});
    background-size: cover;
    width: 1vw;
    height: 1vw;
    position: absolute;
    bottom: -1.5rem;
    right: 0rem;
    transform: rotateZ(180deg);
  }
`
